// extracted by mini-css-extract-plugin
module.exports = {"LessonWrap":"Lesson_LessonWrap__2XROp"};